import { makeStyles } from '@material-ui/styles'

const styles = makeStyles(() => ({
  container: {
  },
}))

export default styles
